import { render } from "./AudienceResources.vue?vue&type=template&id=e653b152&scoped=true"
import script from "./AudienceResources.vue?vue&type=script&lang=js"
export * from "./AudienceResources.vue?vue&type=script&lang=js"

import "./AudienceResources.vue?vue&type=style&index=0&id=e653b152&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3053854672/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e653b152"]])

export default __exports__